export const SET_HRLOOKUP = 'SET_HRLOOKUP'
export const SET_LETTERAPPLY = 'SET_LETTERAPPLY'
